// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBar_NavBarDiv__oTQdN{
    align-self: start;
    display: flex;
    width: 100%;
    height: 70px;
    flex-direction: column;
    @media (max-width: 991px) {
            max-width: 100%}
}

.NavBar_NavBarContainer__4r4oq{
    border-radius: 0px 0px 16.842px 16.842px;
    box-shadow:
        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: var(--boxes, #ffffff);
    align-self: stretch;
    display: flex;
    max-width: 100%;
    height: 100%;
    padding-top: 10px;
    padding-right: 20px;
    padding-left: 14px;
    flex-direction: column;
    @media (max-width: 991px) {
        maxWidth: 100%
    }
}

.NavBar_NavBarContents__10xJU {
    align-self: center;
    z-index: 1;
    display: flex;
    margin-bottom: -15px;
    width: 100%;
    max-width: 1657px;
    align-items: flex-start;
    justify-content:space-between;
    gap: 20px;
    @media (max-width: 991px) {
    max-width: 100%;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: center;
    };
}

.NavBar_NavBarContent1__PmcEC{
    align-self: start;
    display: flex;
    width: 598px;
    max-width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    @media (max-width: 991px) {
        flex-wrap: wrap;
    }
}

.NavBar_logoImg__tXaQ3 {
    aspect-ratio: 4.8;
    object-fit: cover;
    object-position: center;
    width: 268px;
    overflow: hidden;
    align-self: start;
    cursor: pointer;
}

.NavBar_timeAndDateContainer__O5j4F{
    align-items: flex-start;
    align-self: start;
    display: flex;
    margin-top: 9px;
    width: 323px;
    max-width: 100%;
    flex-grow: 1;
    flex-basis: auto;
    justify-content: space-between;
    gap: 20px;
}

.NavBar_timeContent__9m2sN{
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 15.158px;
    font-weight: 600;
    padding-top: 5px;
    align-self: stretch
}

.NavBar_dateContent__nl68x {
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 15.158px;
    font-weight: 600;
    align-self: stretch;
    text-wrap: nowrap;
    @media (max-width: 991px) {
        text-wrap: initial;
    }
}

.NavBar_text2__6T5vx {
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 15.158px;
    font-weight: 600;
    align-self: stretch;
    padding-top: 5px;
    text-wrap: nowrap;
    @media (max-width: 991px) {
        text-wrap: initial;
    }
}

.NavBar_text2__6T5vx span {
    cursor: pointer;
}

.NavBar_NavBarContent2__xshHf {
    height: 40px;
    justify-content: flex-end;
    margin-top: 8px;
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    gap: 12px;
    @media (max-width: 991px) {
        justifyContent: center,
    }
}

.NavBar_dropDownArrow__aN0Bs {
    aspect-ratio: 2;
    object-fit: cover;
    object-position: center;
    width: 10px;
    stroke-width: 1.684px;
    stroke: var(--Secondary, #274C77);
    overflow: hidden;
    align-self: center;
    margin-top: 13px;
    margin-bottom: auto;
}

.NavBar_profileImg__r\\+h92 {
    aspect-ratio: 1.03;
    object-fit: cover;
    object-position: center;
    width: 30px;
    overflow: hidden;
}

.NavBar_signOutIcon__H2-Ri {
    aspect-ratio: 1.03;
    object-fit: cover;
    object-position: center;
    width: 30px;
    overflow: hidden;
    align-self: start;
    margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB;YACQ,eAAe;AAC3B;;AAEA;IACI,wCAAwC;IACxC;oEACgE;IAChE,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,6BAA6B;IAC7B,SAAS;IACT;IACA,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC;wBACoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC;wBACoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,qCAAqC;IACrC;wBACoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":[".NavBarDiv{\n    align-self: start;\n    display: flex;\n    width: 100%;\n    height: 70px;\n    flex-direction: column;\n    @media (max-width: 991px) {\n            max-width: 100%}\n}\n\n.NavBarContainer{\n    border-radius: 0px 0px 16.842px 16.842px;\n    box-shadow:\n        0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: var(--boxes, #ffffff);\n    align-self: stretch;\n    display: flex;\n    max-width: 100%;\n    height: 100%;\n    padding-top: 10px;\n    padding-right: 20px;\n    padding-left: 14px;\n    flex-direction: column;\n    @media (max-width: 991px) {\n        maxWidth: 100%\n    }\n}\n\n.NavBarContents {\n    align-self: center;\n    z-index: 1;\n    display: flex;\n    margin-bottom: -15px;\n    width: 100%;\n    max-width: 1657px;\n    align-items: flex-start;\n    justify-content:space-between;\n    gap: 20px;\n    @media (max-width: 991px) {\n    max-width: 100%;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n    };\n}\n\n.NavBarContent1{\n    align-self: start;\n    display: flex;\n    width: 598px;\n    max-width: 100%;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n    @media (max-width: 991px) {\n        flex-wrap: wrap;\n    }\n}\n\n.logoImg {\n    aspect-ratio: 4.8;\n    object-fit: cover;\n    object-position: center;\n    width: 268px;\n    overflow: hidden;\n    align-self: start;\n    cursor: pointer;\n}\n\n.timeAndDateContainer{\n    align-items: flex-start;\n    align-self: start;\n    display: flex;\n    margin-top: 9px;\n    width: 323px;\n    max-width: 100%;\n    flex-grow: 1;\n    flex-basis: auto;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.timeContent{\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 15.158px;\n    font-weight: 600;\n    padding-top: 5px;\n    align-self: stretch\n}\n\n.dateContent {\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 15.158px;\n    font-weight: 600;\n    align-self: stretch;\n    text-wrap: nowrap;\n    @media (max-width: 991px) {\n        text-wrap: initial;\n    }\n}\n\n.text2 {\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 15.158px;\n    font-weight: 600;\n    align-self: stretch;\n    padding-top: 5px;\n    text-wrap: nowrap;\n    @media (max-width: 991px) {\n        text-wrap: initial;\n    }\n}\n\n.text2 span {\n    cursor: pointer;\n}\n\n.NavBarContent2 {\n    height: 40px;\n    justify-content: flex-end;\n    margin-top: 8px;\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    gap: 12px;\n    @media (max-width: 991px) {\n        justifyContent: center,\n    }\n}\n\n.dropDownArrow {\n    aspect-ratio: 2;\n    object-fit: cover;\n    object-position: center;\n    width: 10px;\n    stroke-width: 1.684px;\n    stroke: var(--Secondary, #274C77);\n    overflow: hidden;\n    align-self: center;\n    margin-top: 13px;\n    margin-bottom: auto;\n}\n\n.profileImg {\n    aspect-ratio: 1.03;\n    object-fit: cover;\n    object-position: center;\n    width: 30px;\n    overflow: hidden;\n}\n\n.signOutIcon {\n    aspect-ratio: 1.03;\n    object-fit: cover;\n    object-position: center;\n    width: 30px;\n    overflow: hidden;\n    align-self: start;\n    margin-left: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavBarDiv": `NavBar_NavBarDiv__oTQdN`,
	"NavBarContainer": `NavBar_NavBarContainer__4r4oq`,
	"NavBarContents": `NavBar_NavBarContents__10xJU`,
	"NavBarContent1": `NavBar_NavBarContent1__PmcEC`,
	"logoImg": `NavBar_logoImg__tXaQ3`,
	"timeAndDateContainer": `NavBar_timeAndDateContainer__O5j4F`,
	"timeContent": `NavBar_timeContent__9m2sN`,
	"dateContent": `NavBar_dateContent__nl68x`,
	"text2": `NavBar_text2__6T5vx`,
	"NavBarContent2": `NavBar_NavBarContent2__xshHf`,
	"dropDownArrow": `NavBar_dropDownArrow__aN0Bs`,
	"profileImg": `NavBar_profileImg__r+h92`,
	"signOutIcon": `NavBar_signOutIcon__H2-Ri`
};
export default ___CSS_LOADER_EXPORT___;
